export default "__VITE_ASSET__d85cb5c2__"